export enum VendorType {
    Open,
    Restricted,
    Private,
}
